import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import AuthHelper from 'Src/common/factories/auth';
import history from 'Src/common/utilities/history';
import VerificationProvider from 'Src/common/providers/verification';
import { isUserVerified } from 'Src/alumniDirectories/actions';
import { DIRECTORY_BASE_PATH } from 'Src/alumniDirectories/endpoints';
import DefaultContainer from './DefaultContainer';
import './style.scss';

const APP_REFRESH_TIME = 299;

/**
 * Directory Details Component
 */
function DirectoryDetails({ match }) {
  const { isLoading, isAuthenticated, getIdTokenClaims, getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    let idTokenInterval = null;
    if (!isLoading) {
      const setToken = async () => {
        await getAccessTokenSilently();
        const claims = await getIdTokenClaims();
        if (claims) {
          AuthHelper.set(claims.__raw);
        }
        if (loading) {
          setLoading(false);
        }
      };
      if (isAuthenticated) {
        setToken();
        idTokenInterval = setInterval(() => {
          setToken();
        }, APP_REFRESH_TIME);
        const targetUrl = sessionStorage.getItem('targetUrl');
        if (targetUrl) {
          history.push(targetUrl);
        }
      } else {
        setLoading(false);
      }
    }
    return () => {
      if (idTokenInterval) {
        clearInterval(idTokenInterval);
      }
    };
  }, [isLoading, isAuthenticated]);

  /**
   * Async function to get Verifications
   */
  async function getVerification() {
    let jwtToken;
    if (isAuthenticated) {
      const tokenClaims = await getIdTokenClaims();
      //eslint-disable-next-line
      jwtToken = tokenClaims?.__raw;
    }
    const response = await isUserVerified(DIRECTORY_BASE_PATH.concat(match.params.slug).concat('/verify/'), {
      jwtToken,
      csrfToken,
    });
    return response.data;
  }

  return (
    <If condition={!isLoading && !loading}>
      <VerificationProvider getVerification={getVerification}>
        <DefaultContainer match={match} />
      </VerificationProvider>
    </If>
  );
}

export default DirectoryDetails;
